import React from "react";

const HowItWorks = () => {
  return (
    <div>
      <div className="  border-b">
        <div className="mx-auto py-12 border-l relative border-r px-12 lg:px-24 max-w-[1200px]">
          <div className="flex items-center w-44 justify-center p-1 bg-gradient-to-b from-gray-100 to-white mx-auto mb-8 rounded-full">
            <div className="px-6 py-2 text-[#697586] font-medium bg-white border border-2 rounded-full geist-mono">
              How it Works
            </div>
          </div>
          <h1 className="text-4xl font-bold text-[#212F40] text-center mb-16">
            Get Started in 3 Simple Steps
          </h1>

          <div className="">
            <div className="flex items-center justify-between gap-12">
              <div className="hidden lg:block w-1/2 p-6 ">
                <img src="/howitworks/step1.svg" alt="" />
              </div>
              <div className="w-full lg:w-1/2">
                <span
                  className="text-8xl font-bold bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(to bottom, #CFD5DE50,#CFD5DE00 )",
                  }}
                >
                  01
                </span>
                <h2 className="text-xl font-semibold text-[#212F40] mb-4">
                  Install SuperMetrics and create an account
                </h2>
                <p className="text-[#344054]">
                  Installation is quick, and creating a SuperMetrics account is
                  completely free.
                </p>
              </div>
            </div>

            <div className="hidden lg:flex justify-center">
              <img
                src="/howitworks/CL1.svg"
                alt="Arrow pointing down"
                className="h-32"
              />
            </div>

            <div className="flex items-center justify-between gap-12">
              <div className="w-full lg:w-1/2">
                <span
                  className="text-8xl font-bold bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(to bottom, #CFD5DE50,#CFD5DE00 )",
                  }}
                >
                  02
                </span>
                <h2 className="text-xl font-semibold text-[#212F40] mb-4">
                  Connect your marketing accounts to SuperMetrics
                </h2>
                <p className="text-[#344054]">
                  Link your accounts to track campaigns and manage materials
                  from one dashboard.
                </p>
              </div>
              <div className="hidden lg:block">
                <img src="/howitworks/step2.svg" alt="" />
              </div>
            </div>

            <div className="hidden lg:flex justify-center">
              <img
                src="/howitworks/CL2.svg"
                alt="Arrow pointing down"
                className="h-32 "
              />
            </div>

            <div className="flex items-center justify-between gap-12">
              <div className="hidden lg:block w-1/2">
                <img src="/howitworks/step3.svg" alt="" />
              </div>
              <div className="w-full lg:w-1/2">
                <span
                  className="text-8xl font-bold bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(to bottom, #CFD5DE50,#CFD5DE00 )",
                  }}
                >
                  03
                </span>
                <h2 className="text-xl font-semibold text-[#212F40] mb-4">
                  Sync data directly to Google Sheets and Slides
                </h2>
                <p className="text-[#344054]">
                  Pull, analyze and integrate your data into documents and
                  presentations.
                </p>
              </div>
            </div>
          </div>


          <div className="absolute -bottom-px -right-px w-4 h-4 border-t-2 border-r-2 border-black rotate-90"></div>

          <div className="absolute left-1 -translate-x-1 -bottom-2 w-4 h-4 rounded-full border border-[#cfd5de] bg-white"></div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
